import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import * as Typography from '../../atoms/Typography/Typography.js';
import PremiumLabel from '../../atoms/PremiumLabel/PremiumLabel.js';
import { ProductCardContainer, ImageContainer, Indicators, Footer, Image } from './ProductCard.styles.js';

var ProductCard = function (_a) {
    var brand = _a.brand, title = _a.title, price = _a.price, imageProps = _a.imageProps, imageSource = _a.imageSource, premium = _a.premium;
    var renderImage = function () {
        if (typeof imageSource === "string") {
            return React.createElement(Image, __assign({ src: imageSource, alt: title }, imageProps));
        }
        return imageSource;
    };
    return (React.createElement(ProductCardContainer, { "aria-label": "ProductCard" },
        React.createElement(ImageContainer, null,
            React.createElement(Indicators, null, premium && React.createElement(PremiumLabel, { value: premium.value, size: "m" })),
            renderImage()),
        React.createElement(Footer, null,
            React.createElement(Typography.Text, { variant: "footnote" }, brand),
            React.createElement(Typography.Text, { variant: "footnote" }, title),
            React.createElement(Typography.Text, { variant: "footnote" }, price))));
};

export { ProductCard as default };
//# sourceMappingURL=ProductCard.js.map
